var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 32,
    viewBox: "0 0 118 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9118 0.00546065C11.966 -0.000809244 15.0991 -0.281343 16.4261 4.17149C17.3201 7.17097 18.7441 12.0843 20.6981 18.9114H21.4939C23.5895 11.7138 25.029 6.80047 25.8125 4.17149C27.1534 -0.327727 30.5057 0.00554881 31.8466 0.00554881L42.1921 0.00556164V31.9999H31.6477V13.1451H30.9406L25.0627 31.9999H17.1294L11.2514 13.1311H10.5444V31.9999H0V0.00556164L10.9118 0.00546065ZM57.3335 0.00556164V18.8744H58.1747L65.3247 3.35869C66.7126 0.271017 69.6708 0.00556164 69.6708 0.00556164H79.8746V32H69.11V13.1311H68.2688L61.259 28.6469C59.8711 31.7206 56.7727 32 56.7727 32H46.569V0.00556164H57.3335ZM117.082 15.2095C115.58 19.4398 110.865 22.4694 105.644 22.4694H94.3553V32H84.1188V15.2095H117.082Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.138 0.00537109H83.582C84.1188 7.12842 90.2889 13.2262 96.6762 13.2262H117.793C119.012 7.30612 114.817 0.00537109 106.138 0.00537109Z",
    fill: "url(#paint0_linear_186_444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_444",
    x1: 118,
    y1: 8.32185,
    x2: 83.582,
    y2: 8.32185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.1677dbb6a0b0451d599070f22e4073dd.svg";
export { ForwardRef as ReactComponent };